import { render, staticRenderFns } from "./smile-tech.vue?vue&type=template&id=0395ab2e&scoped=true&"
import script from "./smile-tech.vue?vue&type=script&lang=js&"
export * from "./smile-tech.vue?vue&type=script&lang=js&"
import style0 from "./smile-tech.vue?vue&type=style&index=0&id=0395ab2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395ab2e",
  null
  
)

export default component.exports